// JCI: Controls only the custom FAQ section; theme accordion scripts are not touched.
(() => {
  const panelSelector = '.jci-product-faq__panel';
  const detailsSelector = '.jci-product-faq__details';
  const summarySelector = '.jci-product-faq__summary';

  const setPanelHeight = (panel) => {
    panel.style.height = `${panel.scrollHeight}px`;
  };

  const clearPanelHeight = (panel) => {
    panel.getAttribute('style');
    panel.removeAttribute('style');
  };

  const openItem = (details, panel) => {
    panel.style.height = '0';
    details.open = true;
    setPanelHeight(panel);

    setTimeout(() => {
      details.classList.add('is-open');
    }, 10);
  };

  const closeItem = (details, panel) => {
    setPanelHeight(panel);
    details.classList.remove('is-open');
    details.classList.add('is-closing');

    setTimeout(() => {
      panel.style.height = '0';
    }, 10);
  };

  const initJciProductFaq = () => {
    const sections = document.querySelectorAll('[data-jci-product-faq]');

    sections.forEach((section) => {
      if (section.dataset.jciProductFaqInitialized === 'true') return;

      const root = section.querySelector('.jci-product-faq');
      const toggle = section.querySelector('[data-jci-faq-toggle]');
      const label = section.querySelector('[data-jci-faq-toggle-label]');

      if (!root) return;

      section.dataset.jciProductFaqInitialized = 'true';

      section.querySelectorAll(`${detailsSelector}[open]`).forEach((details) => {
        details.classList.add('is-open');
      });

      section.addEventListener('click', (event) => {
        const summary = event.target.closest(summarySelector);
        if (!summary || !section.contains(summary)) return;

        event.preventDefault();

        const details = summary.closest(detailsSelector);
        const panel = details && details.querySelector(panelSelector);

        if (!details || !panel) return;

        if (details.open) {
          closeItem(details, panel);
        } else {
          openItem(details, panel);
        }
      });

      section.addEventListener('transitionend', (event) => {
        if (!event.target.matches(panelSelector)) return;

        const panel = event.target;
        const details = panel.closest(detailsSelector);

        if (!details) return;

        if (details.classList.contains('is-closing')) {
          details.classList.remove('is-closing');
          details.open = false;
        }

        clearPanelHeight(panel);
      });

      if (toggle && label) {
        toggle.addEventListener('click', () => {
          const nextExpanded = !root.classList.contains('is-expanded');

          root.classList.toggle('is-expanded', nextExpanded);
          toggle.setAttribute('aria-expanded', String(nextExpanded));
          label.textContent = nextExpanded ? 'Show less' : 'Show more';

          if (!nextExpanded) {
            section.querySelectorAll('[data-jci-faq-extra] details[open], [data-jci-faq-mobile-extra] details[open]').forEach((details) => {
              const panel = details.querySelector(panelSelector);

              if (panel) {
                closeItem(details, panel);
              } else {
                details.open = false;
              }
            });
          }
        });
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initJciProductFaq);
  } else {
    initJciProductFaq();
  }

  document.addEventListener('shopify:section:load', initJciProductFaq);
})();
